import React, { useEffect, useState } from "react";
import { getProfile } from "../../services/localStorageServices";
import {
  FaArrowRightLong,
  FaCartShopping,
  FaCircleUser,
  FaFilePdf,
} from "react-icons/fa6";
import user from "../../Assets/illustration-john-light-0061869a.png";
import { SiLibreofficewriter } from "react-icons/si";
import { Button, List, Table } from "antd";
import { MdDashboard } from "react-icons/md";
import moment from "moment";
import { get } from "../../apiService";
import PrevilageUpdate from "./PrevilageUpdate";
import { FaUser } from "react-icons/fa";

export default function AdminHomeDashboard({ setSelectedKey }) {
  const { profile } = getProfile();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  const [searchInput, setSearchInput] = useState("");
  const [allquote, setAllQuote] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [totalData, setTotalData] = useState({
    order: 0,
    user: 0,
    product: 0,
    quote: 0,
  });

  function formatNumberWithCommas(number) {
    if (isNaN(number)) {
      return "Invalid number";
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const columns = [
    {
      title: "Staff",
      dataIndex: "staff_name",
      key: "staff_name",
    },
    {
      title: "User",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => moment(text).format("llll"),
    },

    {
      title: "View Quotation",
      dataIndex: "quotation_link",
      key: "quotation_link",
      render: (text) => (
        <a target="_blank" href={text} rel="noopener noreferrer">
          <Button className="bg-danger text-white">
            <FaFilePdf /> View
          </Button>
        </a>
      ),
    },
  ];

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchData(pagination.current, pagination.pageSize, searchInput);
    }, 300);
    return () => clearTimeout(dbounce);
  }, [searchInput]);

  const fetchData = async (current, pageSize, search) => {
    try {
      const action = "quote";
      const response = await get(
        `/cart.php?limit=${3}&page=${current}&action=${action}${
          profile?.type === "staff" ? "&staff_id=" + profile?.user_id : ""
        }${search ? "&search=" + search + "" : ""}`
      );
      setAllQuote(response.list);
      setPagination((prevPagination) => ({
        ...prevPagination,
        current,
        pageSize,
        total: response.total, // Assuming the total count is returned in the response
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchStaff(pagination.current, pagination.pageSize, searchInput);
    }, 300);
    return () => {
      clearTimeout(dbounce);
    };
  }, [pagination.current, pagination.pageSize, searchInput]);

  const fetchStaff = async (current, pageSize, search) => {
    try {
      const action = "fetch";
      const type = "staff";
      const response = await get(
        `/user.php?action=${action}&limit=${pageSize}&page=${current}&type=${type}${
          search ? "&search=" + search + "" : ""
        }`
      );
      setStaffData(response.list);
      setPagination((prev) => ({
        ...prev,
        current,
        pageSize,
        total: response.total,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const functionData = async () => {
      try {
        const resp = await get("/totaldata.php");

        if (resp) {
          setTotalData(resp);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const dbounce = setTimeout(() => {
      functionData();
    }, 300);

    return () => clearTimeout(dbounce);
  }, []);

  return (
    <div className="first_dashboard">
      <div className="row">
        <div className="col-lg-8">
          <div className="box_card mb-4">
            <div className="row">
              <div className="col-8">
                <h3>
                  Welcome Back'{" "}
                  <span style={{ textTransform: "capitalize" }}>
                    {profile.type}
                  </span>
                </h3>
                <h4>
                  <FaCircleUser />
                  &nbsp;{profile.name}
                </h4>
                <p>
                  Welcome back! We're glad to have you here. Manage your
                  dashboard and keep everything running smoothly.
                </p>
              </div>
              <div className="col-4">
                <img style={{ width: "100%" }} src={user} />
              </div>
            </div>
          </div>
          <div className="box_card d-none d-lg-block">
            <div className="d-flex justify-content-between">
              <h5 className="mb-3">Recent Quotations</h5>
              <Button
                className="bg-dark text-white"
                onClick={() => setSelectedKey("4")}
              >
                View All&nbsp;
                <FaArrowRightLong />
              </Button>
            </div>
            {/* Table for larger screens */}
            <div className="quotation-table">
              <Table
                columns={columns}
                dataSource={allquote}
                pagination={false}
              />
            </div>
            {/* Cards for smaller screens */}
            <div className="quotation-cards">
              {allquote?.map((quote) => (
                <div className="quotation-card" key={quote.quotation_id}>
                  <p>
                    <strong>User:</strong> {quote.name}
                  </p>
                  <p>
                    <strong>Staff:</strong> {quote.staff_name}
                  </p>
                  <p>
                    <strong>Message:</strong> {quote.message}
                  </p>
                  <p>
                    <strong>Created At:</strong>
                    {moment(quote.created_at).format("llll")}
                  </p>

                  <Button
                    href={quote.quotation_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-danger text-white mt-3"
                  >
                    <FaFilePdf /> View Quotation
                  </Button>
                </div>
              ))}
            </div>{" "}
          </div>
        </div>
        <div className="col-lg-4">
          <div className="row">
            <div className="col-6 mb-4">
              <div className="box_card" onClick={() => setSelectedKey("4")}>
                <div className="header">
                  <div className="iconDetail">
                    <div className="icon quote">
                      <SiLibreofficewriter />
                    </div>
                    <span>Quotations</span>
                  </div>
                  <div className="buttonRedirect">
                    <FaArrowRightLong />
                  </div>
                </div>
                <div className="count">
                  {formatNumberWithCommas(totalData?.quote)}
                </div>
              </div>
            </div>
            <div className="col-6 mb-4">
              <div className="box_card" onClick={() => setSelectedKey("5")}>
                <div className="header">
                  <div className="iconDetail">
                    <div className="icon order">
                      {" "}
                      <FaCartShopping />
                    </div>
                    <span>Orders</span>
                  </div>
                  <div className="buttonRedirect">
                    <FaArrowRightLong />
                  </div>
                </div>
                <div className="count">
                  {formatNumberWithCommas(totalData?.order)}
                </div>
              </div>
            </div>
            <div className="col-6 mb-4">
              <div className="box_card" onClick={() => setSelectedKey("2")}>
                <div className="header">
                  <div className="iconDetail">
                    <div className="icon user">
                      <FaUser />
                    </div>
                    <span>Users</span>
                  </div>
                  <div className="buttonRedirect">
                    <FaArrowRightLong />
                  </div>
                </div>
                <div className="count">
                  {formatNumberWithCommas(totalData?.user)}
                </div>
              </div>
            </div>
            <div className="col-6 mb-4">
              <div className="box_card" onClick={() => setSelectedKey("7")}>
                <div className="header">
                  <div className="iconDetail">
                    <div className="icon product">
                      <MdDashboard />
                    </div>
                    <span>Products</span>
                  </div>
                  <div className="buttonRedirect">
                    <FaArrowRightLong />
                  </div>
                </div>
                <div className="count">
                  {formatNumberWithCommas(totalData?.product)}
                </div>
              </div>
            </div>
          </div>
          <div className="box_card mt-2">
            <div className="d-flex justify-content-between">
              <h5 className="mb-3">Team</h5>
              <Button
                className="bg-danger text-white"
                onClick={() => setSelectedKey("6")}
              >
                View All&nbsp;
                <FaArrowRightLong />
              </Button>
            </div>{" "}
            <List
              className="demo-loadmore-list"
              itemLayout="horizontal"
              dataSource={staffData}
              renderItem={(item) => (
                <List.Item actions={[<PrevilageUpdate data={item} />]}>
                  <List.Item.Meta title={item.name} />
                  <div>{item.user_name}</div>
                </List.Item>
              )}
            />
          </div>
          <div className="box_card mt-4 d-block d-lg-none">
            <div className="d-flex justify-content-between">
              <h5 className="mb-3">Recent Quotations</h5>
              <Button
                className="bg-dark text-white"
                onClick={() => setSelectedKey("4")}
              >
                View All&nbsp;
                <FaArrowRightLong />
              </Button>
            </div>
            {/* Table for larger screens */}
            <div className="quotation-table">
              <Table
                columns={columns}
                dataSource={allquote}
                pagination={false}
              />
            </div>
            {/* Cards for smaller screens */}
            <div className="quotation-cards">
              {allquote?.map((quote) => (
                <div className="quotation-card" key={quote.quotation_id}>
                  <p>
                    <strong>User:</strong> {quote.name}
                  </p>
                  <p>
                    <strong>Staff:</strong> {quote.staff_name}
                  </p>
                  <p>
                    <strong>Message:</strong> {quote.message}
                  </p>
                  <p>
                    <strong>Created At:</strong>
                    {moment(quote.created_at).format("llll")}
                  </p>

                  <Button
                    href={quote.quotation_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-danger text-white mt-3"
                  >
                    <FaFilePdf /> View Quotation
                  </Button>
                </div>
              ))}
            </div>{" "}
          </div>
        </div>
      </div>
    </div>
  );
}
